"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hopperConfigTypes = void 0;
exports.hopperConfigTypes = {
    SET_ERROR: 'CONFIGURATION HOPPER TYPES REDUCER SET ERROR',
    SET_DATA_GRID: 'CONFIGURATION HOPPER TYPES GET DATA GRID',
    ON_PAGE_CHANGE: 'CONFIGURATION HOPPER TYPES ON PAGE CHANGE',
    ON_SORT_CHANGE: 'CONFIGURATION HOPPER TYPES ON SORT CHANGE',
    SET_DATA_BRAND: 'CONFIGURATION HOPPER TYPES SET DATA BRAND',
    ON_MUTATION_CLICK: 'CONFIGURATION HOPPER TYPES ON MUTATION',
    ON_FILTER_CHANGE: 'CONFIGURATION HOPPER TYPES ON FILTER CHANGE',
    ON_SAVE_DATAITEM: 'CONFIGURATION HOPPER TYPES ON SAVE DATAITEM',
    ON_ENTER_EDIT_CLICK: 'CONFIGURATION HOPPER TYPES ON ENTER EDIT',
    ON_CHANGE_DATAITEM: 'CONFIGURATION HOPPER TYPES ON CHANGE DATAITEM',
    TOGGLE_SUCCESS_MODAL: 'CONFIGURATION HOPPER TYPES SET SUCCESS MODAL',
    SET_DATA_ENUM_DUMPING: 'CONFIGURATION HOPPER TYPES GET DATA ENUM DUMPING',
};
